export default "__VITE_ASSET__CxsNWBMZ__"